import React from 'react';
import { Button, Box } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

/**
 * ContactPI Component - Handles contacting Principal Investigators
 * with pre-filled email template
 */
const ContactPI = ({ trial, contact, location, patientProfile }) => {

  const handleEmailContact = () => {
    const subject = `Clinical Trial Inquiry - ${trial.nctId} - Potential Participant via NephroTrax`;
    
    const body = `Dear Dr. ${extractLastName(contact.contactName)},

I am writing to express my interest in your clinical trial:
${trial.title} (${trial.nctId})

I learned about this trial through NephroTrax, a platform that matches amyloidosis patients with appropriate clinical trials. Based on my medical profile, I believe I may meet the eligibility criteria for this study.

PATIENT INFORMATION:
Name: ${patientProfile.firstName} ${patientProfile.lastName}
Amyloid Type: ${patientProfile.amyloidType || 'Not specified'}
Affected Organs: ${patientProfile.affectedOrgans?.join(', ') || 'Not specified'}
Location: ${patientProfile.city}, ${patientProfile.state}

Additional medical information and documentation can be provided upon request through NephroTrax's secure platform.

I would appreciate the opportunity to discuss the following:
1. Current enrollment status and anticipated timeline
2. Screening process and eligibility requirements
3. Travel support or assistance available for study participants
4. Next steps for potential enrollment

NephroTrax can assist with comprehensive travel coordination to your facility, including flight arrangements, accommodation, and ground transportation if needed.

I look forward to learning more about this opportunity to participate in advancing amyloidosis research.

Thank you for your time and consideration.

Sincerely,
${patientProfile.firstName} ${patientProfile.lastName}
${patientProfile.email}
${patientProfile.phoneNumber || 'Phone available upon request'}

---
Facilitated by NephroTrax
www.nephrotrax.com`;

    const mailtoLink = `mailto:${contact.contactEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const handlePhoneCall = () => {
    if (contact.contactPhone) {
      window.location.href = `tel:${contact.contactPhone}`;
    }
  };

  const extractLastName = (fullName) => {
    if (!fullName) return '';
    const parts = fullName.split(',');
    return parts[0].trim();
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {contact.contactEmail && (
        <Button
          variant="contained"
          size="small"
          startIcon={<EmailIcon />}
          onClick={handleEmailContact}
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            textTransform: 'none',
          }}
        >
          Contact PI
        </Button>
      )}
      
      {contact.contactPhone && (
        <Button
          variant="outlined"
          size="small"
          startIcon={<PhoneIcon />}
          onClick={handlePhoneCall}
          sx={{ textTransform: 'none' }}
        >
          {contact.contactPhone}
        </Button>
      )}
    </Box>
  );
};

export default ContactPI;